import {
    apiRequest,
    recapDataTable,
    recapListPeriod,
    detailPeriod,
    recapOrganization,
    recapDownload
} from "../../../../../services/adapters/kepegawaian/penilaian360Service"

class PenilaianRepository 
{
    fetchOrganization = async (query) => {
        return await apiRequest("get", recapOrganization, {
            params: query
        }, true)
    }

    fetchRecapPeriod = async (query, cancelToken) => {
        return await apiRequest("get", recapListPeriod, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchRecapDownload = async (query) => {
        return await apiRequest("get", recapDownload, {
            params: query
        }, true)
    }

    fetchRecapDetailPeriod = async (query) => {
        return await apiRequest("get", detailPeriod, {
            params: query
        }, true)
    }

    fetchDataTable = async (query, cancelToken) => {
        return await apiRequest("get", recapDataTable, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default PenilaianRepository